import { useContext, useEffect, useState, Suspense } from 'react'
import { useLocation } from 'react-router-dom'
import { withStyles } from '@aura/components/styles'
import { useIdleTimer } from 'react-idle-timer'
import PropTypes from 'prop-types'
import SessionTimeout from '../session-timeout'
import appContext from '../../utils/app-context'
import { useConfig } from '../../utils/config'
import styles from './styles'


const ContentContainer = ({
    children
}) => {
    const location = useLocation()
    
    // Check if URL includes magic-link with passwordLessToken
    const isMagicLink = location.pathname.includes('/magic-link')
        && location.search.includes('passwordLessToken')
    
    const config = useConfig()
    const [ displaySessionTimeout, setDisplaySessionTimeout ] = useState(false)

    const { activeSession } = useContext(appContext)

    useEffect(() => {
        setDisplaySessionTimeout(false)
    }, [])

    const handleOnIdle = e => {
        if (activeSession) {
            setDisplaySessionTimeout(true)
        }
    }

    useIdleTimer({
        debounce: 500,
        onIdle: handleOnIdle,
        timeout: 1000 * 60 * config.sessionTimeout
    })

    return (<div>
        {displaySessionTimeout ? <Suspense fallback={null}><SessionTimeout needToShowHelpText={!isMagicLink} customVerbiage = {isMagicLink ? 'sessionTimeoutMagicLink' : ''} /></Suspense> : children}
    </div>)
}

ContentContainer.propTypes = {
    children: PropTypes.object
}

export default withStyles(ContentContainer, styles)
